import i18next from 'i18next';
import ICU from 'i18next-icu';

export function createI18N() {
  const i18n = i18next.createInstance();

  // Use ICU Messages format
  // https://lokalise.com/blog/complete-guide-to-icu-message-format/
  i18n.use(ICU);

  // Backend fallback for loading translations
  // https://www.i18next.com/how-to/backend-fallback
  i18n.use({
    type: 'backend',
    async read(locale: string, _ns: any, callback: any) {
      try {
        // fallback to inline strings when loading english
        if (locale === 'en') {
          return callback(null, {});
        }

        return callback(
          null,
          await import(`../../locales/${locale}/strings.json`)
        );
      } catch (err) {
        // fallback to inlined strings on error
        return callback(null, {});
      }
    },
  });

  i18n.init({
    nsSeparator: false,
    keySeparator: false,
    fallbackLng: false,
  });

  return i18n;
}
